import { render } from "./SearchOrders.vue?vue&type=template&id=605f4428&scoped=true"
import script from "./SearchOrders.vue?vue&type=script&lang=js"
export * from "./SearchOrders.vue?vue&type=script&lang=js"

import "./SearchOrders.vue?vue&type=style&index=0&id=605f4428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605f4428"]])

export default __exports__